/** @format */

import { Offer, Reward, RewardV4Tier } from '@shared/data-access/interfaces';

export interface IReward {
  active?: boolean;
  amount?: string;
  badgeText?: string | null;
  displayTier?: RewardV4Tier;
  expirationDate?: string;
  issueDate?: string;
  message?: string;
  onlineCode?: string;
  redeemed?: boolean;
  status?: string;
  storeCode?: string;
}

export interface IRewardDisplay {
  applied?: boolean;
  disabled?: boolean;
  reward?: Partial<IReward & Reward>;
}

export interface IPickYourPointsDisplay {
  applied?: boolean;
  disabled?: boolean;
  triplePoints?: Partial<ITriplePointsReward & Offer>;
}

export type ITriplePointsRewards = Partial<ITriplePointsReward & Offer>[];

export interface RewardsAndOffers {
  rewards: Partial<IReward & Reward>[];
  offers: ITriplePointsRewards;
}

export interface ITriplePointsReward {
  expirationDate?: string;
  isRedeemed?: boolean;
  redeemedDate?: string;
  redeemedInStore?: boolean;
  rewardCertificateCode?: string;
  status?: number;
}
